﻿import { priceReducedIconSvg, callForPriceCommunityIconSvg, callForPriceHomeIconSvg } from 'constants/svg-assets';
import {
  callForPriceCommunityActiveIconSvg,
  callForPriceHomeActiveIconSvg,
  markerArrowHoverIconSvg,
  markerArrowIconSvg,
  ratingStartIconSvg,
} from 'constants/svg-assets.b1';

const parser = new DOMParser();

export const priceReducedSvgElement = parser.parseFromString(priceReducedIconSvg, 'image/svg+xml').documentElement;

/* Returns the SVG element to use as an icon for call for price in a community. */
export const callForPriceCommunitySvgElement = parser.parseFromString(
  callForPriceCommunityIconSvg,
  'image/svg+xml'
).documentElement;

export const callForPriceCommunityActiveSvgElement = parser.parseFromString(
  callForPriceCommunityActiveIconSvg,
  'image/svg+xml'
).documentElement;

/* Returns the SVG element to use as an icon for call for price in a home. */
export const callForPriceHomeSvgElement = parser.parseFromString(
  callForPriceHomeIconSvg,
  'image/svg+xml'
).documentElement;

export const callForPriceHomeActiveSvgElement = parser.parseFromString(
  callForPriceHomeActiveIconSvg,
  'image/svg+xml'
).documentElement;

export const ratingStarSvgElement = parser.parseFromString(ratingStartIconSvg, 'image/svg+xml').documentElement;

export const markerArrowSvgElement = parser.parseFromString(markerArrowIconSvg, 'image/svg+xml').documentElement;

export const markerArrowHoverSvgElement = parser.parseFromString(
  markerArrowHoverIconSvg,
  'image/svg+xml'
).documentElement;
